import Vue from 'vue';
import Vuex from 'vuex';
import service from '../service';
import router from '../router';
import log from '../service/log';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    feedbackSubmitted: false,
    feedbackPreviouslySubmitted: false,
    isLoading: false,
    review: {},
  },
  mutations: {
    FEEDBACK_SUBMITTED: state => {
      state.feedbackSubmitted = true;
    },
    FEEDBACK_PREVIOUSLY_SUBMITTED: state => {
      state.feedbackPreviouslySubmitted = true;
    },
    SET_USER_DATA: (state, data) => {
      state.review = data;
    },
    SET_IS_LOADING: (state, data) => {
      state.isLoading = data;
    },
    SET_REVIEW_ID: (state, data) => {
      state.reviewId = data;
    },
  },
  actions: {
    async getData({ commit }, id) {
      commit('SET_IS_LOADING', true, { root: true });
      commit('SET_REVIEW_ID', id);
      try {
        const res = await service.getData(id);
        commit('SET_USER_DATA', res.data.payload);
        if (res.data.payload.feedbackSubmitted) {
          commit('FEEDBACK_PREVIOUSLY_SUBMITTED');
          router.push('/feedback-submitted').catch(() => {});
        }
      } catch (e) {
        router.push('/error').catch(() => {});
        log(e);
      } finally {
        commit('SET_IS_LOADING', false, { root: true });
      }
    },
    async submitFeedback({ commit }, payload) {
      commit('SET_IS_LOADING', true, { root: true });
      try {
        await service.submitFeedback(this.state.reviewId, payload);
        commit('FEEDBACK_SUBMITTED');
        router.push('/thank-you').catch(() => {});
      } catch (e) {
        router.push('/error').catch(() => {});
        log(e);
      } finally {
        commit('SET_IS_LOADING', false, { root: true });
      }
    },
  },
  modules: {},
});
